import { z } from 'zod';
/**
 * Unified Principal — see docs/architecture.md §4.4.3.
 * Zod is the source of truth; the TS type is inferred.
 */
export const AuthTierSchema = z.enum(['manager', 'store_ops']);
export const AuthMethodSchema = z.enum(['entra', 'pin']);
export const PrincipalSchema = z.object({
    tier: AuthTierSchema,
    userId: z.string().min(1),
    orgId: z.string().uuid(),
    groups: z.array(z.string()),
    scopedStoreIds: z.array(z.string().uuid()),
    authMethod: AuthMethodSchema,
    deviceId: z.string().uuid().optional(),
    shiftId: z.string().uuid().optional(),
});
export const BaristaRoleSchema = z.enum(['barista', 'shift_lead']);
//# sourceMappingURL=principal.js.map